const languages: any = {
    it: require('./it.json'),
    en: require('./en.json'),
    fr: require('./fr.json'),
};

export const getRequestedLanguages = (languageCode: string) => {
    if (languages[languageCode]) {
        return languages[languageCode];
    }
    return languages.it;
};
